import { useEffect, useState } from 'react'

import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { HtmlConnected as Html } from '../html'
import { heading, options } from './options'

export const InterestsPageComponent = ({
  project = {},
  properties,
  interests,
  loading,
  onSubmit,
}) => {
  const { t } = useTranslation()
  const currency = project.currency

  const [state, setState] = useState(
    interests || {
      properties: [],
      parking: false,
      addonOption: false,
    }
  )
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleSubmit = (ev) => {
    ev.preventDefault()
    setSubmitted(true)
    if (!project.mandatoryInterests) {
      onSubmit(state)
    } else {
      if (state.properties.length) {
        onSubmit(state)
      }
    }
  }

  const isValid = !!state.properties.length

  const head = heading(project.propertyVisibleFields)

  const minimumInterests = project.minimumInterests || 3

  const f = state.properties.filter((v) => !!v && v !== 0)
  let fields = f
  if (fields.length < minimumInterests) {
    fields = fields.concat(
      Array.from(new Array(minimumInterests - fields.length)).map(() => '')
    )
  }

  if (project.noLimitInterests && f.length >= minimumInterests) {
    fields = [...fields, '']
  }

  const defaultLabels = [
    t('First choice'),
    t('Second choice'),
    t('Third choice'),
  ]

  const getLabel = (i) => {
    const choice = i + 1
    if (minimumInterests === 3 && !project.noLimitInterests) {
      return defaultLabels[i]
    } else {
      if (choice === 1) {
        return `${choice}${t('st')} ${t('choice')}`
      } else if (choice === 2) {
        return `${i + 1}${t('nd')} ${t('choice')}`
      } else if (choice === 3) {
        return `${choice}${t('rd')} ${t('choice')}`
      } else {
        return `${choice}${t('th')} ${t('choice')}`
      }
    }
  }

  return (
    <Stack component="form" spacing={3} onSubmit={handleSubmit}>
      <Html name="choose-properties" />
      <Stack spacing={1} sx={{ maxWidth: 'sm' }}>
        {fields.map((id, ind) => {
          const labelId = `property-select-label-${ind + 1}`
          return (
            <FormControl
              key={id || `empty-${ind}`}
              variant="outlined"
              error={submitted && !isValid}
            >
              <InputLabel id={labelId}>{getLabel(ind)}</InputLabel>
              <Select
                labelId={labelId}
                label={getLabel(ind)}
                inputProps={{
                  name: `propertyId${ind + 1}`,
                }}
                value={id}
                onChange={(e) => {
                  const val = parseInt(e.target.value)
                  setState({
                    ...state,
                    properties: fields
                      .map((v, i) => (i === ind ? val : v))
                      .filter((v) => !!v && v !== 0),
                  })
                }}
              >
                <MenuItem value="">{head}</MenuItem>
                {options(
                  properties,
                  state.properties,
                  project.propertyVisibleFields,
                  currency
                )}
              </Select>
            </FormControl>
          )
        })}
        {project.parking && (
          <FormControlLabel
            label={<Html name="parking" />}
            control={
              <Checkbox
                name="parking"
                checked={state.parking}
                onChange={() =>
                  setState({
                    ...state,
                    ...{ parking: !state.parking },
                  })
                }
              />
            }
          />
        )}
        {project.addonOption && (
          <FormControlLabel
            label={<Html name="addon-option" />}
            control={
              <Checkbox
                name="addonOption"
                checked={state.addonOption}
                onChange={() =>
                  setState({
                    ...state,
                    ...{ addonOption: !state.addonOption },
                  })
                }
              />
            }
          />
        )}
      </Stack>
      <Stack direction="row" alignItems="center" spacing={3}>
        <Button
          variant="contained"
          type="submit"
          onSubmit={handleSubmit}
          loading={loading}
        >
          {t('Continue')}
        </Button>
      </Stack>
    </Stack>
  )
}
